import { getHttpClient, errorDesconocido, safeHandle401 } from "../../../core/utils/httpClient";

export function error(error) {
    return { type: "CONFIG_INFORMATION_ERROR", error };
}

export function loading(loading) {
    return { type: "CONFIG_INFORMATION_LOADING", loading };
}

export function success(payload) {
    return { type: "CONFIG_INFORMATION_SUCCESS", payload };
}

export function load(force = false) {
    return async (dispatch, getState) => {
        const now = Date.now().valueOf() / 1000;
        const timestamp = getState().config.information ? getState().config.information.timestamp : 0;

        /**
         * Comprobamos si la ultima información es reciente (de la ultima hora)
         */
        if (now < timestamp + 3600 && force === false) {
            return;
        }

        dispatch(loading(true));
        dispatch(error(""));

        var headers = {
            "Content-Type": "application/json",
        };

        try {
            const cliente = await getHttpClient(dispatch, getState());
            const response = await cliente.get("react/v1/configurations/information", {}, { headers: headers });

            dispatch(success(response.data));
            dispatch(loading(false));

            return response.data;
        } catch (e) {
            dispatch(loading(false));
            const test401 = safeHandle401(dispatch, getState);
            test401(e);

            if (e.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                if (e.response.status == 404) {
                    dispatch(error(e.response.data));
                } else if (e.response.status != 400) {
                    errorDesconocido();
                }

                return e.response.data;
            }

            dispatch(error("Error desconocido"));
            errorDesconocido();
            return "Error";
        }
    };
}

export function expire() {
    return { type: "CONFIG_INFORMATION_EXPIRE" };
}

export function reset() {
    return { type: "CONFIG_INFORMATION_RESET" };
}
